import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type UserTreeQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  searchQuery?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortBy?: Types.InputMaybe<Types.UserSortingField>;
  sortOrder?: Types.InputMaybe<Types.SortOrder>;
  filter?: Types.InputMaybe<Types.UserFilterInput>;
  withAmsCodes: Types.Scalars['Boolean']['input'];
}>;


export type UserTreeQuery = { __typename?: 'Query', users: { __typename?: 'Users', paginated: { __typename?: 'UserPaginatedResult', totalHits: number, items: Array<{ __typename?: 'User', firstName?: string | null, lastName?: string | null, fullName: string, id: string, amsRoles: Array<Types.UserAmsRole>, shortNames?: Array<string> }> } } };


export const UserTreeDocument = gql`
    query UserTree($limit: Int, $offset: Int, $searchQuery: String, $sortBy: UserSortingField, $sortOrder: SortOrder, $filter: UserFilterInput, $withAmsCodes: Boolean!) {
  users {
    paginated(
      filter: $filter
      pagination: {limit: $limit, offset: $offset, sortBy: $sortBy, sortOrder: $sortOrder}
      query: $searchQuery
    ) {
      items {
        firstName
        lastName
        fullName
        id
        amsRoles
        shortNames @include(if: $withAmsCodes)
      }
      totalHits
    }
  }
}
    `;

/**
 * __useUserTreeQuery__
 *
 * To run a query within a React component, call `useUserTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTreeQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchQuery: // value for 'searchQuery'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *      withAmsCodes: // value for 'withAmsCodes'
 *   },
 * });
 */
export function useUserTreeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserTreeQuery, UserTreeQueryVariables> & ({ variables: UserTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserTreeQuery, UserTreeQueryVariables>(UserTreeDocument, options);
      }
export function useUserTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserTreeQuery, UserTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserTreeQuery, UserTreeQueryVariables>(UserTreeDocument, options);
        }
// @ts-ignore
export function useUserTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserTreeQuery, UserTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserTreeQuery, UserTreeQueryVariables>;
export function useUserTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserTreeQuery, UserTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserTreeQuery | undefined, UserTreeQueryVariables>;
export function useUserTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserTreeQuery, UserTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserTreeQuery, UserTreeQueryVariables>(UserTreeDocument, options);
        }
export type UserTreeQueryHookResult = ReturnType<typeof useUserTreeQuery>;
export type UserTreeLazyQueryHookResult = ReturnType<typeof useUserTreeLazyQuery>;
export type UserTreeSuspenseQueryHookResult = ReturnType<typeof useUserTreeSuspenseQuery>;
export type UserTreeQueryResult = Apollo.QueryResult<UserTreeQuery, UserTreeQueryVariables>;